import React from 'react';
import { Table } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import NotAuthorised from '../errors/NotAuthorised';
import HoverActionButtons from '../buttons/HoverActionButtons';
import HoverActionButtonsContent from './HoverActionButtonsContent';

const cellClasses = (content, className) => {
  const classes = ['aridhia-editable-cell', 'overflow-initial', className];
  if (!content) {
    classes.push('no-content');
  }

  return classes.join(' ');
};

const HoverActionButtonsCell = ({
  canEdit,
  canRead,
  className,
  colSpan,
  content,
  copyToClipboard,
  disabled,
  exists,
  href,
  link,
  message = 'click.to.edit',
  onClick,
  showEdit,
  showUrlLinks,
  title,
  width,
  showPopup,
}) => {
  const intl = useIntl();
  if (!canRead) {
    return (
      <Table.Cell colSpan={colSpan}>
        <NotAuthorised />
      </Table.Cell>
    );
  }

  if (!exists) {
    return <Table.Cell colSpan={colSpan} />;
  }

  return (
    <Table.Cell
      className={cellClasses(content, className)}
      colSpan={colSpan}
      title={title}
      width={width}
    >
      <HoverActionButtons
        canEdit={canEdit}
        showEdit={showEdit}
        value={content}
        editCopyMods="table-cell"
        disabled={disabled}
        copyToClipboard={copyToClipboard}
      >
        <HoverActionButtonsContent
          content={content}
          href={href}
          link={link}
          messageText={canEdit ? intl.formatMessage({ id: message }) : ''}
          onClick={onClick}
          showUrlLinks={showUrlLinks}
          showPopup={showPopup}
        />
      </HoverActionButtons>
    </Table.Cell>
  );
};

export default HoverActionButtonsCell;
